import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance, { isAxiosError } from "@/utils/axiosInstance";
import { Params } from "@/types";

const endpoint = {
  roles: "/roles",
};

export const fetchRole = createAsyncThunk(
  "roles/fetchRole",
  async (params: Params, thunkAPI) => {
    try {
      const response = await axiosInstance.get(endpoint.roles, {
        params,
      });
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        return thunkAPI.rejectWithValue({ error: error.message });
      } else {
        return thunkAPI.rejectWithValue({
          error: "An unknown error occurred",
        });
      }
    }
  },
);

export const createRole = createAsyncThunk(
  "roles/createRole",
  async (data: { name: string }, thunkAPI) => {
    try {
      const response = await axiosInstance.post(endpoint.roles, data);
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        return thunkAPI.rejectWithValue({ error: error.message });
      } else {
        return thunkAPI.rejectWithValue({
          error: "An unknown error occurred",
        });
      }
    }
  },
);

export const updateRole = createAsyncThunk(
  "roles/updateRole",
  async (data: any, thunkAPI) => {
    try {
      const response = await axiosInstance.put(
        `${endpoint.roles}/${data.slug}`,
        data,
      );
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        return thunkAPI.rejectWithValue({ error: error.message });
      } else {
        return thunkAPI.rejectWithValue({
          error: "An unknown error occurred",
        });
      }
    }
  },
);

export const deleteRole = createAsyncThunk(
  "roles/deleteRole",
  async (slug: string, thunkAPI) => {
    try {
      const response = await axiosInstance.delete(`${endpoint.roles}/${slug}`);
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        return thunkAPI.rejectWithValue({ error: error.message });
      } else {
        return thunkAPI.rejectWithValue({
          error: "An unknown error occurred",
        });
      }
    }
  },
);
